module.exports = __webpack_public_path__ + "media/images/flags/CZ-379d04f1ba6769123446cb97f136b8ca.svg";